import { UseQueryOptions } from 'react-query'

// eslint-disable-next-line
export const lovQueryOptions: UseQueryOptions<any> = { staleTime: Infinity }
